// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2uz5T","dragIcon":"SortableItem_dragIcon___Y1JA","disabled":"SortableItem_disabled__31wKN"};